// src/theme/tokens/spacing.js
// Source of truth for Figma spacing tokens

export const spacing = {
  px4: 4,     // space-1
  px8: 8,     // space-2
  px12: 12,   // space-3
  px16: 16,   // space-4
  px20: 20,   // space-5
  px24: 24,   // space-6
  px32: 32,   // space-8
  px40: 40,   // space-10
  px48: 48,   // space-12
  px64: 64,   // space-16
  px80: 80,   // space-20
  px96: 96,   // space-24
  px128: 128, // space-32
  px160: 160, // space-40
  px192: 192, // space-48
  px224: 224, // space-56
  px256: 256, // space-64
};

